import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/images/offroad/offroad-botas.svg")